import './PrivacyPolicyPage.css';

function PrivacyPolicyPage() {
  return (
    <main className="privacy-page" aria-labelledby="privacy-title">
      <section className="section privacy-section">
        <div className="container privacy-container">
          <article className="privacy-document reveal">
            <header className="privacy-header">
              <p className="eyebrow">Genius Software S.A.S.</p>
              <h1 id="privacy-title" className="section-title privacy-title">
                Política de Privacidad
              </h1>
            </header>

            <div className="privacy-content">
              <p>
                Genius Software S.A.S. informa que los datos personales ingresados en formularios
                de contacto, anuncios, campañas publicitarias o consultas comerciales serán
                utilizados únicamente para responder solicitudes, brindar asesoramiento comercial,
                coordinar reuniones y enviar información relacionada con nuestros servicios.
              </p>

              <p>
                Los datos recopilados pueden incluir nombre, apellido, email, teléfono, empresa,
                cargo y cualquier otra información que el usuario decida compartir voluntariamente.
              </p>

              <p>
                Genius Software S.A.S. no vende ni cede los datos personales a terceros con fines
                comerciales. La información será tratada de manera confidencial y utilizada solamente
                para la gestión de consultas comerciales, seguimiento de oportunidades y comunicación
                con personas interesadas en nuestros servicios.
              </p>

              <p>
                El usuario podrá solicitar la modificación, actualización o eliminación de sus datos
                personales escribiendo a:
              </p>

              <p>
                <a href="mailto:comercial@sistemasgenius.com">comercial@sistemasgenius.com</a>
              </p>

              <p>
                Al enviar un formulario o consulta, el usuario acepta que Genius Software S.A.S.
                utilice sus datos para contactarlo por email, teléfono, WhatsApp u otros medios
                informados.
              </p>

              <section className="privacy-contact" aria-labelledby="privacy-contact-title">
                <h2 id="privacy-contact-title">Datos de contacto:</h2>
                <p>Genius Software S.A.S.</p>
                <p>Córdoba 836, Rosario, Santa Fe, Argentina</p>
                <p>
                  WhatsApp:{' '}
                  <a href="https://wa.me/5493416926584" target="_blank" rel="noreferrer">
                    341 6926584
                  </a>
                </p>
                <p>
                  Email:{' '}
                  <a href="mailto:comercial@sistemasgenius.com">comercial@sistemasgenius.com</a>
                </p>
                <p>
                  Sitio web:{' '}
                  <a href="http://www.sistemasgenius.com" target="_blank" rel="noreferrer">
                    www.sistemasgenius.com
                  </a>
                </p>
              </section>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
}

export default PrivacyPolicyPage;
